<script>
	import { page } from '$app/stores';
	import NavDropdown from './NavDropdown.svelte';
	import { PWA } from '$lib/pwa.js';

	const aboutItems = [
		{ label: 'About Our Church', href: '/about' },
		{ label: 'Patron Saint of Our Church', href: '/patron-saint' },
		{ label: 'Our Pastor', href: '/pastor' },
		{ label: 'Armenian Church Origin', href: '/armenian-church-origin' },
		{ label: 'Church Services', href: '/services' },
		{ label: 'Get In Touch', href: '/contact' },
	];

	const faithItems = [
		{ label: 'What We Believe', href: '/faith' },
		{ label: 'Saints & Feast Days', href: '/faith/feast-days' },
		{ label: 'Saints of the Armenian Church', href: '/faith/saints' },
	];

	const communityItems = [
		{ label: 'ACYOA Juniors', href: '/community/acyoa-juniors' },
		// Lab-only until these pages are ready for prod
		...(PWA.isLab
			? [
					{ label: 'Adult Choir', href: '/community/adult-choir' },
					{ label: 'Altar Servers', href: '/community/altar-servers' },
					{ label: 'Chess Club', href: '/community/chess-club' },
					{ label: 'Cultural Committee', href: '/community/cultural-committee' },
					{ label: 'Kirikian Armenian School', href: '/community/kirikian-armenian-school' },
					{ label: 'Parish Council', href: '/community/parish-council' },
					{ label: 'Sunday School', href: '/community/sunday-school' },
					{ label: 'Youth Orchestra', href: '/community/youth-orchestra' },
				]
			: []),
	];
</script>

<!-- Desktop header -->
<header class="fixed inset-x-0 top-0 z-40 hidden border-b border-stone-dark bg-altar-white/80 backdrop-blur-sm md:block">
	<nav class="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
		<a href="/" class="flex items-center gap-3 text-xl font-semibold font-heading text-wine">
			<img src="/images/church-logo-transparent.png" alt="" class="h-8 w-8 rounded" />
			St. Thomas Armenian Apostolic Church
			{#if PWA.isLab}
				<span class="rounded bg-wine px-1.5 py-0.5 text-xs font-semibold uppercase tracking-wide text-altar-white">Lab</span>
			{/if}
		</a>

		<div class="flex items-center gap-8">
			<NavDropdown label="About" items={aboutItems} currentPath={$page.url.pathname} />
			<NavDropdown label="Faith" items={faithItems} currentPath={$page.url.pathname} />
			<NavDropdown label="Community" items={communityItems} currentPath={$page.url.pathname} />

			<a
				href="/events"
				class="text-sm font-medium transition-colors {$page.url.pathname === '/events' ? 'text-wine' : 'text-navy hover:text-wine'}"
			>
				Events
			</a>

			<a
				href="/articles"
				class="text-sm font-medium transition-colors {$page.url.pathname === '/articles' ? 'text-wine' : 'text-navy hover:text-wine'}"
			>
				Articles
			</a>

			<a
				href="/gallery"
				class="text-sm font-medium transition-colors {$page.url.pathname.startsWith('/gallery') ? 'text-wine' : 'text-navy hover:text-wine'}"
			>
				Gallery
			</a>

			<a
				href="/watch"
				class="text-sm font-medium transition-colors {$page.url.pathname === '/watch' ? 'text-wine' : 'text-navy hover:text-wine'}"
			>
				Watch Live
			</a>
		</div>
	</nav>
	<div class="h-px bg-gradient-to-r from-transparent via-gold to-transparent"></div>
</header>

<!-- Mobile header -->
<header class="border-b border-stone-dark bg-altar-white md:hidden">
	<div class="px-6 py-3 text-center">
		<a href="/" class="inline-flex items-center gap-2 text-lg font-semibold font-heading text-wine">
			<img src="/images/church-logo-transparent.png" alt="" class="h-7 w-7 rounded" />
			St. Thomas Armenian Church
			{#if PWA.isLab}
				<span class="rounded bg-wine px-1.5 py-0.5 text-xs font-semibold uppercase tracking-wide text-altar-white">Lab</span>
			{/if}
		</a>
	</div>
</header>
